<script lang="ts">
import { defineComponent } from "vue";
import IconSprite from "@/components/IconSprite.vue";
import AnfrageService from "@/businesslogic/services/AnfrageService";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "BeratungDirekt",
  components: { IconSprite },
  setup() {
    const piniaStore = useFormStore();

    const beratungAnfordern = (kontext: string) => {
      AnfrageService.beratungAnfordern(
        piniaStore.getSessionToken(piniaStore.state),
        "BeratungDirekt",
        piniaStore.state,
        "beratung_anfordern_" + kontext,
      );
    };

    return {
      beratungAnfordern,
    };
  },
});
</script>

<template>
  <div class="o-grid o-grid--align-center u-mar-y-2">
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--5-480">
      <div class="o-media-object">
        <div class="o-media-object__media">
          <icon-sprite icon-name="icon-phone" css-klassen="u-color-secondary" />
        </div>
        <div class="o-media-object__content">
          <span>
            <a class="inherited" href="tel:+49-40-3766-3366" @click="beratungAnfordern('Telefon')"
              >Tel.: 040 3766 3366</a
            >
          </span>
        </div>
      </div>
    </div>
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--5-480">
      <div class="o-media-object">
        <div class="o-media-object__media">
          <icon-sprite css-klassen="u-color-secondary" icon-name="icon-paper-airplane" />
        </div>
        <div class="o-media-object__content">
          <span>
            <a class="inherited" href="mailto:kundenservice@grundvers.de" @click="beratungAnfordern('E-Mail')">
              kundenservice@grundvers.de
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
